module.exports = require('component-event');


// WEBPACK FOOTER //
// ./~/min-dom/lib/event.js